import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubjectContainerForm } from '../Forms/SubjectContainerForm';

type SubjectContainerModalProps = {
  subjectContainerUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const SubjectContainerModal = ({ subjectContainerUuid, isOpen, onClose }: SubjectContainerModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      title={subjectContainerUuid ? t('subjectContainer.edit') : t('subjectContainer.add')}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <SubjectContainerForm subjectContainerUuid={subjectContainerUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
